// extracted by mini-css-extract-plugin
export default {"page":"AliasManager_page__FUzEz"};